export const drawerFooterStyle = () => `
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    width: 100%;
`;
